var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseList',{attrs:{"items":_vm.bladesWithModel},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('BladeListItem',{attrs:{"item":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }